export const getters = {
  runningLoaders(state) {
    return state.loaders;
  },
  canStartGuide(state, guideName) {
    return state.autoPlayGuides.includes(guideName);
  },
};
